var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.703,
    height: 18.705,
    viewBox: "0 0 18.703 18.705",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M2.193,18.7A2.2,2.2,0,0,1,0,16.511V3.652A2.193,2.193,0,0,1,2.193,1.463H3.07V0H4.527V1.463h9.648V0h1.457V1.463h.877A2.193,2.193,0,0,1,18.7,3.652V16.511A2.2,2.2,0,0,1,16.51,18.7Zm-.73-2.194a.73.73,0,0,0,.73.731H16.51a.73.73,0,0,0,.73-.731V6.868H1.463Zm0-12.859V5.405H17.24V3.652a.733.733,0,0,0-.73-.731h-.877V4.383H14.176V2.92H4.527V4.383H3.07V2.92H2.193A.733.733,0,0,0,1.463,3.652ZM11.629,15.9V14.192H12.91V15.9Zm-2.988,0V14.192h1.707V15.9Zm-2.992,0V14.192H6.93V15.9Zm-2.988,0V14.192H4.367V15.9Zm11.961-2.988V11.2H15.9v1.711Zm-2.992,0V11.2H12.91v1.711Zm-2.988,0V11.2h1.707v1.711Zm-2.992,0V11.2H6.93v1.711Zm-2.988,0V11.2H4.367v1.711ZM14.621,9.918V8.211H15.9V9.918Zm-2.992,0V8.211H12.91V9.918Zm-2.988,0V8.211h1.707V9.918Zm-2.992,0V8.211H6.93V9.918Zm-2.988,0V8.211H4.367V9.918Z",
    fill: "#2d335d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.6cf76985ac652da44c82ecef2f53f3c9.svg";
export { ForwardRef as ReactComponent };